import { Component, OnInit, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { OrderStatusConstants } from 'src/app/core/constants/order-status-constants';
import { DeltaDate } from 'src/app/core/infrastructure/delta-date';
import { OrderFacade } from 'src/app/store/order/facade';
import { OrderModel } from 'src/app/store/order/model';
import { Title } from '@angular/platform-browser';
import { ServiceCategoryModel, ServiceModel } from 'src/app/store/self-diagnostic/service-catalog/model';
import { List } from 'src/app/core/infrastructure/linq';
import { ServiceCatalogFacade } from 'src/app/store/self-diagnostic/service-catalog/facade';
import { AppConstants } from 'src/app/core/constants/app-constants';
import { UserFacade } from 'src/app/store/user/facade';
import { UserModel } from 'src/app/store/user/model';
import notify from 'devextreme/ui/notify';
import { AbstractOrdersSearchResaltViewTemplateApiService } from 'src/app/core/services/abstract/abstract-orders-search-resalt-view-template-api-service';
import { OrdersSearchResaltTableColumnViewModel } from 'src/app/store/orders-search-resalt-view-template/model';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss'],
  standalone: false,
})
export class OrdersComponent implements OnInit {
  translate = inject(TranslateService);
  private orderFacade = inject(OrderFacade);
  private titleService = inject(Title);
  private serviceCatalogFacade = inject(ServiceCatalogFacade);
  private userFacade = inject(UserFacade);
  private resaltViewTemplateApiService = inject(AbstractOrdersSearchResaltViewTemplateApiService);

  // DRAFT: in the process of development of SearchResaltViewTemplate
  // @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;

  private user: UserModel | null = null;
  private categories: List<ServiceCategoryModel> | undefined = undefined;
  //private filterMode: string = '';

  public isUkLanguage: boolean = true;
  public order$: Observable<OrderModel[]> = this.orderFacade.allOrders$;
  public columns: OrdersSearchResaltTableColumnViewModel[] = [];

  ngOnInit(): void {
    // Page title
    this.translate.get('TITLE_ORDERS_PAGE').subscribe(page => {
      this.translate.get('TITLE_MAIN').subscribe(main => {
        this.titleService.setTitle(page + ' ' + main);
      });
    });

    this.initResaltViewTemplate();

    this.userFacade.selected().subscribe(u => {
      this.user = u;

      if (this.user) {
        this.loadResaltViewTemplate(this.user.id);
      }
    });

    this.isUkLanguage = this.translate.currentLang == AppConstants.LANGUAGE_UK;

    // this.orderFacade.getFilterType().subscribe(x => {
    //  this.filterMode = x;
    //});

    // DRAFT: in the process of development of SearchResaltViewTemplate
    // TODO: remake the OrdersSearchResaltTableColumnView on order$ parameter like "filterMode"
    // this.orderFacade.getFilterType().subscribe(x => {
    //   this.filterMode = x;
    // });

    this.serviceCatalogFacade.entities$.subscribe(s$ => {
      this.categories = new List<ServiceModel>(s$)
        .Select(s => s?.category)
        .DistinctBy(sc => sc?.code)
        .OrderBy(sc => sc?.nameUa)
        .Select(
          sc =>
            <ServiceCategoryModel>{
              id: sc!.id,
              code: sc?.code,
              nameUa: sc?.nameUa,
              nameRu: sc?.nameRu,
              webNameUa: sc?.webNameUa,
              webNameRu: sc?.webNameRu,
              descriptionUa: sc?.descriptionUa,
              descriptionRu: sc?.descriptionRu,
              priority: sc?.priority,
              iconBody: sc?.iconBody,
              iconType: sc?.iconType,
              masterCategoryId: sc?.masterCategoryId,
              masterCategory: sc?.masterCategory,
            }
        );
    });
  }

  // TODO: remake on Redux
  private async loadResaltViewTemplate(userId: number) {
    let response = await this.resaltViewTemplateApiService.getViewForUser(userId).toPromise();

    if (response?.isSucceeded) {
      if (response.result?.template) {
        this.columns = response.result?.template;
      }
    } else {
      notify("Can't load view template", 'error', 3000);
    }
  }

  // TODO: remake on Redux
  public async saveResaltViewTemplate(userId: number, viewTemplate: OrdersSearchResaltTableColumnViewModel[]) {
    let response = await this.resaltViewTemplateApiService.setViewForUser(userId, viewTemplate).toPromise();

    if (!response?.isSucceeded) {
      notify("Can't save view template", 'error', 3000);
    }
  }

  changeResaltViewTemplate($event) {
    // Visibility of the column
    if ($event.fullName.endsWith('visible') && $event.name === 'columns') {
      let regex: RegExp = /(?<=\[).*(?=\])/g; // value between '[' and ']'
      let columnIndex = +regex.exec($event.fullName);

      this.columns.forEach(element => {
        if (element.id === columnIndex + 1 && $event.value != $event.previousValue && element.visible != $event.value) {
          element.visible = $event.value;

          this.saveResaltViewTemplate(this.user!.id, this.columns);
        }
      });
    }

    // DRAFT: in the process of development of SearchResaltViewTemplate
    // // Column Reordering
    // if ($event.fullName.endsWith("visibleIndex") && $event.name === "columns") {
    //   // TODO: how to get the position of other columns?
    //   // console.log($event);
    //   // console.log(this.dataGrid.columns);
    // }

    // DRAFT: in the process of development of SearchResaltViewTemplate
    // // Column Resizing width
    // if ($event.fullName.endsWith("width") && $event.name === "columns") {
    //   // TODO: too many events - event for each pixel width change
    //   // console.log($event);
    // }
  }

  private initResaltViewTemplate() {
    this.columns = [
      {
        id: 1,
        caption: 'Дата створення',
        dataField: 'createDate',
        name: 'createDate',
        showInColumnChooser: true,
        visible: true,
      },
      {
        id: 2,
        caption: 'Тип',
        dataField: 'category.value',
        name: 'category.value',
        showInColumnChooser: true,
        visible: true,
      },
      {
        id: 3,
        caption: 'Номер заявки',
        dataField: 'id',
        name: 'id',
        showInColumnChooser: true,
        visible: true,
      },
      {
        id: 4,
        caption: 'IT сервіс',
        dataField: 'this.getServiceCategoryName(order.data)',
        name: 'this.getServiceCategoryName(order.data)',
        showInColumnChooser: true,
        visible: true,
      },
      {
        id: 5,
        caption: 'Тема',
        dataField: 'title',
        name: 'title',
        showInColumnChooser: true,
        visible: true,
      },
      {
        id: 6,
        caption: 'Остання дія',
        dataField: 'lastComment',
        name: 'lastComment',
        showInColumnChooser: true,
        visible: true,
      },
      {
        id: 7,
        caption: 'Для кого',
        dataField: 'employeeFor?.fio',
        name: 'employeeFor?.fio',
        showInColumnChooser: true,
        visible: true,
      },
      {
        id: 8,
        caption: 'Статус',
        dataField: 'status.value',
        name: 'status.value',
        showInColumnChooser: true,
        visible: true,
      },
      {
        id: 9,
        caption: 'Буде виконано',
        dataField: 'getTimeLeft(order.data)',
        name: 'getTimeLeft(order.data)',
        showInColumnChooser: true,
        visible: true,
      },
    ];
  }

  getVisibilityForColumn(rowId: number): boolean {
    return this.columns && this.columns[rowId] ? this.columns[rowId].visible : true;
  }

  rowCick($event) {
    if ($event.isExpanded) {
      $event.component.collapseRow($event.data.id);
    } else {
      $event.component.expandRow($event.data.id);
    }
  }

  getColorByStatus(statusId: number) {
    switch (statusId) {
      case OrderStatusConstants.OrderStatuses.RequiresClarification:
      case OrderStatusConstants.OrderStatuses.RefinementOfParameters:
      case OrderStatusConstants.OrderStatuses.WaitingForAuthorizationConfirmation:
      case OrderStatusConstants.OrderStatuses.ForApproval:
      case OrderStatusConstants.OrderStatuses.WaitingForConfirmationOfCosts:
      case OrderStatusConstants.OrderStatuses.RequiresConfirmationByITSecurity:
      case OrderStatusConstants.OrderStatuses.WaitingForConfirmationFromITSecurity:
      case OrderStatusConstants.OrderStatuses.RequiresChangeManagerConfirmation:
      case OrderStatusConstants.OrderStatuses.WaitingForChangeManagerConfirmation:
        return '#ffffff';
      case OrderStatusConstants.OrderStatuses.AppointedToTheHead:
      case OrderStatusConstants.OrderStatuses.AcceptedByTheHead:
      case OrderStatusConstants.OrderStatuses.AssignedToPerformer:
      case OrderStatusConstants.OrderStatuses.HiredByThePerformer:
      case OrderStatusConstants.OrderStatuses.PostponedByTheHead:
      case OrderStatusConstants.OrderStatuses.PostponedByThePerformer:
      case OrderStatusConstants.OrderStatuses.StageCompleted_AssignmentToTheHead:
        return '#ffffff';
      case OrderStatusConstants.OrderStatuses.ParametersSpecified:
      case OrderStatusConstants.OrderStatuses.Agreed:
      case OrderStatusConstants.OrderStatuses.Processed:
      case OrderStatusConstants.OrderStatuses.CostsConfirmed:
      case OrderStatusConstants.OrderStatuses.RequiresImprovement:
      case OrderStatusConstants.OrderStatuses.AssignmentError:
      case OrderStatusConstants.OrderStatuses.CostMatchingRequired:
      case OrderStatusConstants.OrderStatuses.Creating:
      case OrderStatusConstants.OrderStatuses.StageCompleted_911:
      case OrderStatusConstants.OrderStatuses.SelectingACoordinator:
        return '#856404';
      case OrderStatusConstants.OrderStatuses.Closed:
      case OrderStatusConstants.OrderStatuses.CancelRequest:
      case OrderStatusConstants.OrderStatuses.Completed:
      case OrderStatusConstants.OrderStatuses.Confirmed:
      case OrderStatusConstants.OrderStatuses.Confirmed_2:
        return '#084616';
      case OrderStatusConstants.OrderStatuses.DenialOfService:
      case OrderStatusConstants.OrderStatuses.Postponed911:
        return '#ffffff';
    }
  }

  getBackgroundColorByStatus(statusId: number) {
    switch (statusId) {
      case OrderStatusConstants.OrderStatuses.RequiresClarification:
      case OrderStatusConstants.OrderStatuses.RefinementOfParameters:
      case OrderStatusConstants.OrderStatuses.WaitingForAuthorizationConfirmation:
      case OrderStatusConstants.OrderStatuses.ForApproval:
      case OrderStatusConstants.OrderStatuses.WaitingForConfirmationOfCosts:
      case OrderStatusConstants.OrderStatuses.RequiresConfirmationByITSecurity:
      case OrderStatusConstants.OrderStatuses.WaitingForConfirmationFromITSecurity:
      case OrderStatusConstants.OrderStatuses.RequiresChangeManagerConfirmation:
      case OrderStatusConstants.OrderStatuses.WaitingForChangeManagerConfirmation:
        return '#51adcf';
      case OrderStatusConstants.OrderStatuses.AppointedToTheHead:
      case OrderStatusConstants.OrderStatuses.AcceptedByTheHead:
      case OrderStatusConstants.OrderStatuses.AssignedToPerformer:
      case OrderStatusConstants.OrderStatuses.HiredByThePerformer:
      case OrderStatusConstants.OrderStatuses.PostponedByTheHead:
      case OrderStatusConstants.OrderStatuses.PostponedByThePerformer:
      case OrderStatusConstants.OrderStatuses.StageCompleted_AssignmentToTheHead:
        return '#9088d4';
      case OrderStatusConstants.OrderStatuses.ParametersSpecified:
      case OrderStatusConstants.OrderStatuses.Agreed:
      case OrderStatusConstants.OrderStatuses.Processed:
      case OrderStatusConstants.OrderStatuses.CostsConfirmed:
      case OrderStatusConstants.OrderStatuses.RequiresImprovement:
      case OrderStatusConstants.OrderStatuses.AssignmentError:
      case OrderStatusConstants.OrderStatuses.CostMatchingRequired:
      case OrderStatusConstants.OrderStatuses.Creating:
      case OrderStatusConstants.OrderStatuses.StageCompleted_911:
      case OrderStatusConstants.OrderStatuses.SelectingACoordinator:
        return '#f3eac2';
      case OrderStatusConstants.OrderStatuses.Closed:
      case OrderStatusConstants.OrderStatuses.CancelRequest:
      case OrderStatusConstants.OrderStatuses.Completed:
      case OrderStatusConstants.OrderStatuses.Confirmed:
      case OrderStatusConstants.OrderStatuses.Confirmed_2:
        return '#b8e8b8';
      case OrderStatusConstants.OrderStatuses.DenialOfService:
      case OrderStatusConstants.OrderStatuses.Postponed911:
        return '#fd8c04';
    }
  }

  getTimeLeft(order: OrderModel): string {
    return DeltaDate.getTimeLeftByTimeSec(order.execCountdown);
  }

  getClassForTimeLeft(order: OrderModel) {
    if (order.orderTime != null) {
      let planTime = order.orderTime + order.orderReact911Time;
      let factTime = planTime - order.execCountdown;
      let procent = (factTime * 100) / planTime;

      if (procent >= 0 && procent <= 50) {
        return 'order-status-bg order-status-success';
      } else if (procent > 50 && procent <= 80) {
        return 'order-status-bg order-status-warning';
      } else {
        return 'order-status-bg order-status-alert';
      }
    } else {
      return '';
    }
  }

  getIconClass(order: OrderModel) {
    let inPausedIcon = 'order-icon-status mdi mdi-pause-circle';
    let notInPausedIcon = 'order-icon-status mdi mdi-progress-clock';
    let doneIconForSpecialStatus = 'order-icon-status mdi mdi-checkbox-marked';
    let falseIconForSpecialStatus = 'order-icon-status mdi mdi-close-circle';

    let iconClass = '';

    if (
      order.status.id === OrderStatusConstants.OrderStatuses.Closed ||
      order.status.id === OrderStatusConstants.OrderStatuses.Completed ||
      order.status.id === OrderStatusConstants.OrderStatuses.Confirmed
    ) {
      if (order.execCountdown >= 0) {
        iconClass = doneIconForSpecialStatus;
      } else {
        iconClass = falseIconForSpecialStatus;
      }
    } else {
      if (order.isPaused) {
        iconClass = inPausedIcon;
      } else {
        iconClass = notInPausedIcon;
      }
    }

    return iconClass;
  }

  calcServiceCategoryName = (rowData: any) => {
    return this.getServiceCategoryName(rowData);
  };

  getServiceCategoryName(order: OrderModel): string {
    let serviceCategoryName = order.service?.value;

    if (this.categories?.Any()) {
      let category = this.categories.FirstOrDefault(sc => sc?.code == order.service?.id);
      if (category) {
        if (this.isUkLanguage) {
          serviceCategoryName = category.webNameUa ? category.webNameUa : category.nameUa;
        } else {
          serviceCategoryName = category.webNameRu ? category.webNameRu : category.nameRu;
        }
      }
    }

    return serviceCategoryName;
  }
}
